import { DatePicker, TimePicker } from 'antd';
import styled, { css } from 'styled-components/macro';

const AntdCommonStyle = css<{ $hasError?: boolean; additionalStyle?: string }>`
  height: 2.5rem;
  width: 100%;
  border-radius: ${({ theme }) => theme.spacing.zero_1};
  color: ${({ theme }) => theme.colors.black_100};
  border-color: ${({ theme, $hasError }) =>
    $hasError ? theme.colors.negative_dark : theme.colors.black_20};
  box-shadow: none;

  :hover {
    border-color: ${({ additionalStyle, theme }) =>
      additionalStyle ? theme.colors.dark : theme.colors.black_10};
  }

  > .ant-picker-input > input {
    font-size: 16px;
    font-family: ${({ theme }) => theme.fontFamily.regular};

    ::placeholder {
      color: ${({ additionalStyle, theme }) =>
        additionalStyle ? theme.colors.dark : theme.colors.black_60};
    }
  }

  margin-bottom: ${({ theme }) => theme.spacing.one_2};

  ${({ additionalStyle }) =>
    additionalStyle &&
    `${additionalStyle}
  
   &.ant-picker-focused {
    border-bottom: 1px solid #000000 !important;
    box-shadow: none;
  }
  `};

  @media only screen and (max-width: 425px) {
    .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels {
      flex-direction: column;
    }
    .ant-picker-dropdown .ant-picker-range-wrapper {
      justify-content: center;
    }
  }
`;

export const DatePickerWrapper = styled.div``;

export const TimePickerStyled = styled(TimePicker)`
  ${AntdCommonStyle}

  .ant-picker-footer-extra {
    padding: 0;
  }
`;

export const RangePickerStyled = styled(TimePicker.RangePicker)`
  ${AntdCommonStyle}
`;

export const DatePickerStyled = styled(DatePicker)`
  ${AntdCommonStyle}
`;

export const TimePickerFooter = styled.div`
  display: grid;
  grid-auto-flow: column;
`;

export const TimePickerFooterText = styled.div`
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily.medium};
`;
